var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,attrs:{"type":_vm.type,"disabled":_vm.disabled,"title":_vm.titleWithToggle},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.$slots.icon)?_c('div',{staticClass:"cf-c-btn--with-icon__icon"},[_vm._t("icon")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }